import { ICsv,ICsvType } from '../../../types/record/csv';
import {
  ICsvAPIValidationErrorFactory,
  ICsvAPIValidationErrorType,
  CsvAPIRawSuccessResponseType,
  CsvAPIRawValidationErrorType
} from '../../types/csv/api-response';
import { nullableToStringList } from '../nullable-to-string-list';

export const ICsvFromAPISuccessResponse = ({
  id,
  name,
}: CsvAPIRawSuccessResponseType): ICsvType =>
  ICsv({
    id,
    name: name,
  });

export const ICsvAPIValidationError = ({
  name,
}: CsvAPIRawValidationErrorType): ICsvAPIValidationErrorType =>
  ICsvAPIValidationErrorFactory({
    name: nullableToStringList(name),
  });
